import { types as t } from 'mobx-state-tree';

export const StepModel = t
  .model('StepModel', {
    id: t.maybeNull<any>(t.string),
    isValid: t.optional(t.boolean, false),
    canSave: t.optional(t.boolean, true),
    name: t.maybeNull<any>(t.string),
    status: t.maybeNull<any>(t.string),
  })
  .actions((self) => ({
    allowSave(canSave = true) {
      self.canSave = canSave;
    },
    valid(isValid = true) {
      self.isValid = isValid;
    },
  }));
